<template>
  <div class="container">
    <h2>Obtain Transport Keys from this page</h2>
    <h3 class="text-danger">Environment {{ selected }}</h3>
    <p>Please click generate keys below</p>
    <div
      v-if="loading"
      class="row d-flex justify-content-center align-middle my-4"
    >
      <h3>Loading magical things :)</h3>
    </div>
    <VueyeTable
      :data="rows"
      :columns="columns"
      title="Keys"
      filter-by="vehicle_id"
      v-show="rows.length"
    >
    </VueyeTable>
    <div class="container">
      <label class="message" for="selected">Select an environment</label>
      <select
        class="form-select my-2"
        aria-label="Select an environment"
        v-model="selected"
      >
        <option selected>Select an environment</option>
        <!--        <option value="qa">QA</option>-->
        <option value="stgTwo">STG</option>
        <option value="prod">PROD</option>
      </select>
    </div>
    <div class="py-3" style="text-align: center">
      <button class="ty-button" v-on:click="getKeys">Generate New Keys</button>
    </div>
  </div>
</template>

<script>
import VueyeTable from "vueye-table";

export default {
  name: "dkkeys",
  data: () => ({
    keys: null,
    error: null,
    loading: false,
    qaURL: "https://gvw9p1ejk4.execute-api.us-west-2.amazonaws.com/dev/dkinfo",
    stgURL:
      "https://g58qoi07i9.execute-api.us-west-2.amazonaws.com/staging/dkinfo",
    stgOneURL:
      "https://0optl75mw9.execute-api.us-west-2.amazonaws.com/staging/dkinfostgone",
    stgTwoURL:
      "https://iawtvi82bi.execute-api.us-west-2.amazonaws.com/staging/dkinfostgtwob",
    prodURL:
      "https://72iix315pa.execute-api.us-west-2.amazonaws.com/staging/registervehicle",
    selected: "prod",
    columns: [
      {
        label: "TransportKey ID",
        key: "label",
        display: true,
        sortable: true,
      },
    ],
    rows: [],
  }),
  components: {
    VueyeTable,
  },
  methods: {
    generateENVURL: function () {
      if (this.selected === "stgTwo") {
        return this.stgTwoURL;
      }
      if (this.selected === "prod") {
        return this.prodURL;
      } else {
        return this.prodURL;
      }
    },
    getKeys: function () {
      console.log("Selected Environment: ", this.generateENVURL());
      const ENV_URL = this.generateENVURL();
      this.keys = null;
      this.error = null;
      this.loading = true;
      const config = {
        method: "get",
        url: ENV_URL,
      };

      this.axios(config)
        .then((response) => {
          this.loading = false;
          // eslint-disable-next-line no-console
          console.log("response: ", response.data.results);
          this.rows = response.data.results.rows;
        })
        .catch((error) => {
          this.loading = false;
          this.error = error;
        });
    },
  },
};
</script>

<style scoped>
body {
  font-family: ToyotaType-Regular, sans-serif;
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.ty-button {
  background: #d92429;
  border-radius: 0px;
  width: 320px;
  height: 56px;
  font-family: ToyotaType-Semibold;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0.73px;
  text-align: center;
}

.qr-container {
  padding-top: 40px;
  text-align: center;
  height: 300px;
  /*background-color: #4281ff;*/
  height: 540px;
}
</style>
